<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  beforeDelete,
  remove,
  update,
} from '@/api/v4ward/park/lot/parkinglot';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 80,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        align: 'center',
        labelWidth: 110,
        indexLabel: '序号',
        dialogWidth: '30%',
        column: [
          {
            label: '停车场编号',
            prop: 'parkingLotCode',
            editDisabled: true,
            maxlength: 32,
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入停车场编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车场名称',
            prop: 'parkingLotName',
            maxlength: 32,
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入车场名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车场总车位数',
            prop: 'parkingSpaceCount',
            type: 'number',
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入车场总车位数',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 3,
            maxlength: 128,
            span: 24,
          },
        ],
      },
      data: [],
    };
  },
  activated() {
    let self = this;
    setTimeout(() => {
      this.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      window.addEventListener(
        'resize',
        () => {
          self.$refs.crud.doLayout(); //窗口缩放解决表格错位
        },
        false
      );
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkinglot_add, true),
        viewBtn: this.vaildData(this.permission.parkinglot_view, false),
        delBtn: this.vaildData(this.permission.parkinglot_delete, true),
        editBtn: this.vaildData(this.permission.parkinglot_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      beforeDelete({ id: row.id }).then((res) => {
        if (res.data) {
          this.$alert('检测到车场有关联数据，请先删除其它信息！', {
            confirmButtonText: '确定',
            type: 'warning',
          });
        } else {
          this.$confirm('确定将选择数据删除?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return remove({ id: row.id });
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
            });
        }
      });
    },

    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style>
.avue-crud__dialog .el-dialog__body {
  padding-right: 60px;
}
</style>
